import { ref } from "vue";
import { useStore } from 'vuex'
import { useToast } from 'vue-toastification';

export function useRecorder(language,onError) {
    const transcripts = ref([]);
    const isRecording = ref(false);
    const isTranscribing = ref(false);
    const errorMessage = ref("");
    const combinedTranscript = ref(""); 
    let websocket = null;
    let reconnectTimeout = null; 
    const store = useStore();
    const isPaused = ref(false);
    const toast = useToast();
    let silenceStart = null
    let silenceWarned = false
    const SILENCE_MS = 2000
    const SILENCE_THRESHOLD = 0.01
  const visualStream = ref(null)

    

    console.log(language.value);

    const startStreaming = (mode) => {
        errorMessage.value = "";
        transcripts.value = [];
        combinedTranscript.value = "";
        isRecording.value = true;
        isTranscribing.value = false;
        isPaused.value = false;

        connectWebSocket(mode);
    };
    const pauseRecording = async () => {
        if (!audioContext) return
        isPaused.value = true
        if (audioContext.state === 'running') {
            await audioContext.suspend()
        }
        
    };

    const resumeRecording = async () => {
        if (!audioContext) return
        if (audioContext.state === 'suspended') {
            await audioContext.resume()
        }
        isPaused.value = false
    };
    const connectWebSocket = (mode) => {
        websocket = new WebSocket("wss://ai-stage.ensofia.app:8443/fast/stream_ws");
        websocket.onopen = () => {
            console.log("streaming WebSocket connection established.");
            store.commit('websocket/SET_STREAM_CONNECTED', true)
            startRecording(mode);
        };

        websocket.onmessage = (event) => {
            const data = JSON.parse(event.data);

            const last = transcripts.value[transcripts.value.length - 1];
            if (last && last.transcript === data.transcript && last.isFinal === data.is_final) {
                return;
                }

                if (data.is_final) {
                transcripts.value.push(data.transcript);
                combinedTranscript.value = transcripts.value.join(" "); 

                // if (!isRecording.value) {
                //     isTranscribing.value = false;
                // }
            }
                console.log( combinedTranscript.value)

        };

        websocket.onerror = (error) => {
            console.error("streaming WebSocket error:", error);
            errorMessage.value = "An error occurred with the streaming WebSocket connection.";
            isTranscribing.value = false;
            stopStreaming();
        };

        websocket.onclose = (event) => {
            console.log(" streamingWebSocket connection closed:", event);
            store.commit('websocket/SET_STREAM_CONNECTED', false)



            if (isRecording.value) {
                reconnectTimeout = setTimeout(() => {
                console.log("Reconnecting streaming WebSocket...");
                connectWebSocket();
                }, 500);
            }
        
            stopRecording();
            isTranscribing.value = false;
        };
    };
    const stopStreaming = () => {
        isPaused.value = false;
        if (isRecording.value) {
            isTranscribing.value = true; 
        }
        if (websocket) {
            console.log("Stopping WebSocket streaming connection...");
            isRecording.value = false;

            // setTimeout(() => {
                if (websocket) {
                websocket.close();
                websocket = null;
                isTranscribing.value = true;
                // console.log("WebSocket streaming connection closed after delay.");
                    }
                // }, 3000); 
            }
        
            if (reconnectTimeout) {
                clearTimeout(reconnectTimeout);
                reconnectTimeout = null;
            }
    };

    let mediaRecorder;
    let audioContext = null;

    let displayStream = null;
    let micStream = null;
    let mixedStream = null;

    let destination = null;
    let processorNode = null;

    const startRecording = async (mode) => { 
        micStream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const track = micStream?.getAudioTracks?.()[0];
        if (!track) {
            toast.error("No microphone detected.");
            return;
            }

            // 🔇 Detect hardware / OS mute
            track.onmute = () => {
                toast.error("Microphone is muted.");
                setTimeout(() => {
                    pauseRecording();
                }, 1000);
            };

            track.onunmute = () => {
                toast.success("Microphone unmuted");
                resumeRecording();
            };

            // 🔌 Detect unplug
            track.onended = () => {
                toast.error("Microphone disconnected.");
                setTimeout(() => {
                    pauseRecording();
                }, 1000);
            };

        if (!audioContext) audioContext = new (window.AudioContext || window.webkitAudioContext)();

        if (audioContext.state === 'suspended') {
            try { await audioContext.resume(); } catch {
                console.log(audioContext)
            }
        }

        try {
            if (mode === 'online') { 
                
                // ------------------------------------------
                // ONLINE MODE → MIX MEET AUDIO + MIC AUDIO
                // ------------------------------------------
                displayStream = await navigator.mediaDevices.getDisplayMedia({
                    video: true,
                    audio: true,
                });

                // micStream = await navigator.mediaDevices.getUserMedia({ audio: true });

                const meetSource = audioContext.createMediaStreamSource(displayStream);
                const micSource = audioContext.createMediaStreamSource(micStream);

                destination = audioContext.createMediaStreamDestination();
                meetSource.connect(destination);
                micSource.connect(destination);

                mixedStream = destination.stream; // ⬅️ SAME
                visualStream.value = mixedStream
                const mixedSourceNode = audioContext.createMediaStreamSource(mixedStream);

                processorNode = audioContext.createScriptProcessor(4096, 1, 1);
                mixedSourceNode.connect(processorNode);
                processorNode.connect(audioContext.destination);

                processorNode.onaudioprocess = (event) => {
                    if (websocket && websocket.readyState === WebSocket.OPEN) {
                        const audioData = event.inputBuffer.getChannelData(0);
                        const audioBuffer = new Int16Array(audioData.length);
                        if (isPaused.value) return

                        const hasSound = audioData.some(s => Math.abs(s) > SILENCE_THRESHOLD)

                        if (!hasSound) {
                        if (!silenceStart) silenceStart = Date.now()
                        if (!silenceWarned && Date.now() - silenceStart > SILENCE_MS) {
                            toast.error("No audio detected (silence). Please speak or check the microphone.")
                            silenceWarned = true
                            pauseRecording();
                        }
                        } else {
                        silenceStart = null
                        silenceWarned = false
                        }
                        for (let i = 0; i < audioData.length; i++) {
                            audioBuffer[i] = audioData[i] * 0x7fff;
                        }
                        websocket.send(audioBuffer.buffer);
                    }
                };

                mediaRecorder = {
                    stream: micStream,
                    mixedStream,
                    processor: processorNode,
                    source: mixedSourceNode,
                    meetSource,
                    micSource,
                };

            } else {
                // ------------------------------------------
                // OFFLINE MODE → OLD MIC-ONLY LOGIC
                // ------------------------------------------
                micStream = await navigator.mediaDevices.getUserMedia({ audio: true });

                const micSource = audioContext.createMediaStreamSource(micStream);
                processorNode = audioContext.createScriptProcessor(4096, 1, 1);

                micSource.connect(processorNode);
                processorNode.connect(audioContext.destination);
                visualStream.value = micStream;

                processorNode.onaudioprocess = (event) => {
                    if (websocket && websocket.readyState === WebSocket.OPEN) {
                        const audioData = event.inputBuffer.getChannelData(0);
                        const audioBuffer = new Int16Array(audioData.length);
                        for (let i = 0; i < audioData.length; i++) {
                            audioBuffer[i] = audioData[i] * 0x7fff;
                        }
                        websocket.send(audioBuffer.buffer);
                    }
                };

                mediaRecorder = {
                    stream: micStream,
                    processor: processorNode,
                    source: micSource,
                };
            }

            isRecording.value = true;

        } catch (err) {
            console.error("Error accessing audio:", err);
            const msg = mapMicError(err);
            errorMessage.value = msg;
            isRecording.value = false;

            if (onError && typeof onError === "function") {
                onError(msg);
            }
            stopStreaming();
        }
    };

    const mapMicError = (err) => {
        const name = err?.name || ''
        if (name === 'NotAllowedError' || name === 'PermissionDeniedError')
        return 'Microphone access denied. Please allow mic permissions and retry.'
        if (name === 'NotFoundError')
        return 'No microphone detected. Please connect a mic and try again.'
        if (name === 'NotReadableError')
        return 'Microphone is busy or in use by another app.'
        if (name === 'SecurityError')
        return 'Microphone requires HTTPS or a secure context.'
        return 'Could not access the microphone. Please check permissions.'
    }

    const stopRecording = () => {
        if (mediaRecorder) {

            if (mediaRecorder.stream) {
                mediaRecorder.stream.getTracks().forEach((track) => track.stop());
            }

            if (displayStream) {       
                displayStream.getTracks().forEach((track) => track.stop());
                displayStream = null;
            }

            if (micStream) {        
                micStream.getTracks().forEach((track) => track.stop());
                micStream = null;
            }

            if (mediaRecorder.processor) {
                mediaRecorder.processor.disconnect();
            }

            if (mediaRecorder.source) {   
                mediaRecorder.source.disconnect();
            }

            mediaRecorder = null;
            visualStream.value = null
        }

        if (processorNode) {
            processorNode.disconnect();
            processorNode = null;
        }

        if (destination) { 
            destination = null;  
        }

        mixedStream = null;  
    };

    return {
        isRecording,
        transcription: combinedTranscript,
        errorMessage,
        startRecording: startStreaming,
        stopRecording: stopStreaming,
        isTranscribing,
        pauseRecording,  
        resumeRecording,
        isPaused,
         visualStream,
    };
}
